<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-9 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">Prospects</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-body">
            <section id="basic-tabs-components">
                <div class="row match-height">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <ul class="nav nav-tabs" role="tablist">
                                    <!-- <li class="nav-item">
                                        <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" aria-controls="home" role="tab" aria-selected="true">Demandes de création de comptes</a>
                                    </li> -->
                                    <li class="nav-item">
                                        <a class="nav-link active" id="profile-tab" data-toggle="tab" href="#profile" aria-controls="profile" role="tab" aria-selected="true">Ayant demandé une négociation</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="other-tab" data-toggle="tab" href="#other" aria-controls="other" role="tab" aria-selected="false">Ayant sauvegardé une souscription</a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <!-- <div class="tab-pane active" id="home" aria-labelledby="home-tab" role="tabpanel">
                                        <all-prospect/>
                                    </div> -->
                                    <div class="tab-pane active" id="profile" aria-labelledby="profile-tab" role="tabpanel">
                                        <negotiated-prospect/>
                                    </div>
                                    <div class="tab-pane" id="other" aria-labelledby="other-tab" role="tabpanel">
                                        <save-prospect/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import allProspect from './item/all.vue'
    import negotiatedProspect from './item/negotiated.vue'
    import saveProspect from './item/save.vue'
    export default {
        name: "list",
        components: { allProspect, negotiatedProspect, saveProspect },
        data: () => ({

        }),
        created() {
        },
        methods:{

        }
    }
</script>

<style scoped>

</style>
